<div id="client-status-toolbar">
  @if (contingencyEnabled()) {
    <div>
      <div class="mr-8 s-16 flex-row"
        [matTooltip]="'Alguns recursos são limitados no Modo de Contingência.\n\nRecursos indisponíveis:\n• Impressora R2\n• Meus impressos\n• Meus arquivos\n• Meus uploads'"
        [style.cursor]="'pointer'"
        matTooltipClass="my-tooltip-multiline"
        (click)="openClient($event)">
        @if (clientStatus) {
          <div class="client-status-icon">
            <!--fadeInOut-->
            <div [@fadeIn]>
              <fa-icon [ngClass]="'client-contingency-mode'" [icon]="faCircle"></fa-icon>
            </div>
          </div>
        }
        <div class="contingence-mode-title">
          Modo Contingência
        </div>
      </div>
    </div>
  }
  @if (!contingencyEnabled()) {
    <div>
      <div class="mr-8 s-16 flex-row"
        [matTooltip]="agentTooltip"
        [style.cursor]="agentStatusCursor"
        (click)="agentStatusClick($event)">
        @if (clientStatus) {
          <div class="client-status-icon">
            <!--fadeInOut-->
            <div [@fadeIn]>
              <fa-icon [ngClass]="agentIconClass" [icon]="agentIcon"></fa-icon>
            </div>
          </div>
        }
        <div class="ml-16">
          Agente
        </div>
      </div>
      @if (clientStatus) {
        @if (clientStatus.status === R2CloudClientStatus.CLIENT_UPDATE) {
          <div class="client-update">
            <div class="arrow_box">
              <div class="inner_box ">
                <b>Atualizando agente.</b>
              </div>
            </div>
          </div>
        }
      }
    </div>
  }

</div>